/**
 * Loaded local file matches are keyed by track id and belong to one crate view.
 * Clear them when navigating to a different crate, not when the same crate is refetched
 * (e.g. after Spotify import while rows already loaded matches from the in-memory crate).
 *
 * Module scope survives React remounts of the crate page for the same id.
 */
let trackMatcherBoundCrateId: string | undefined;

export function resetTrackMatcherBoundCrateId(): void {
  trackMatcherBoundCrateId = undefined;
}

export function shouldClearTrackMatchesForCrateId(
  nextCrateId: string,
): boolean {
  return trackMatcherBoundCrateId !== nextCrateId;
}

export function markTrackMatcherBoundToCrateId(nextCrateId: string): void {
  trackMatcherBoundCrateId = nextCrateId;
}

/** @internal test helper */
export function getTrackMatcherBoundCrateIdForTests(): string | undefined {
  return trackMatcherBoundCrateId;
}
